import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { usePermissions, ModuleName } from '../hooks/use-permissions.hook';

interface PermissionRouteProps {
  module: ModuleName;
  requireWrite?: boolean;
  redirectTo?: string;
}

function PermissionRoute({
  module,
  requireWrite = false,
  redirectTo = '/no-access'
}: PermissionRouteProps) {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const permissionType = requireWrite ? 'write' : 'read';
  const isAllowed = hasPermission(module, permissionType);

  useEffect(() => {
    if (!isAllowed) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAllowed, navigate, redirectTo]);

  if (!isAllowed) return null;

  return <Outlet />;
}

export default PermissionRoute;
